import React from 'react';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';

// Helpers
import { closeDrawer, getURLSegment } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import DatePicker from 'react-datepicker';
import moment from 'moment';

const ReportFilter = observer(class ReportFilter extends React.Component {
  componentWillMount() {
    this.state = {
      institutions: null
    };

    // Bind this to functions
    this.getInstitutions = this.getInstitutions.bind(this);
  }

  handleChange(key, value, exact) {
    const { reportFilters } = this.props.store.ReportStore;

    if(exact) {
      reportFilters[key] = value;
    } else {
      reportFilters[key] = `*${value}*`;
    }
  }

  handleDateChange(date, key) {
    const { reportFilters } = this.props.store.ReportStore;
    const formattedDate = moment(date).local().toISOString();

    reportFilters[key] = formattedDate;

    // Store the new date in state for display
    this.setState({
      [key]: date
    });
  }

  handleSubmit(e) {
    const { ReportStore } = this.props.store;

		closeDrawer(e, this.props.parent);

		ReportStore.getReportData(getURLSegment(this, 2));
  }

  getInstitutions() {
    const { SessionStore } = this.props.store;

    if(!SessionStore.installs) {
      SessionStore.getInstalls();
    }
  }

  render() {
    const { translation } = this.props;
    const { ReportStore, SessionStore } = this.props.store;
    const { reportFilters, reportFilterMap } = ReportStore;

    if(!SessionStore.loading) {
      return (
        <div className="drawer__content">
          <header className="drawer__header">
            <div className="wrap">
              <h1 className="drawer__title">Filter Report</h1>
            </div>
          </header>

          <div className="panel panel--brief">
            <form className="" onSubmit={(e) => this.handleSubmit(e)} noValidate>
              <fieldset>
                <ul className="fields">

                  {/* Loop through properties of the filter map */}
                  {Object.keys(reportFilterMap).map(
                    (key, i) => {
                      // Get the typeof to determine what kind of field we need
                      const dataType = typeof reportFilterMap[key];

                      if(dataType === 'number') {
                        // Number-based filter
                        return (
                          <li
                            key={i}
                            className="field--select-text"
                          >
                            <label htmlFor={key}>
                              {translation[`${key}_label`] || key}
                            </label>

                            <label className="select">
                              <select id={key}>
                                <option value="=">{translation.number.equals}</option>
                                <option value=">">{translation.number.greater_than}</option>
                                <option value="<">{translation.number.less_than}</option>
                              </select>
                            </label>

                            <input
                              type="number"
                              placeholder="0"
                            />
                          </li>
                        )
                      } else if(Array.isArray(toJS(reportFilterMap[key]))) {
                        // Select-based filter
                        return (
                          <li
                            key={i}
                          >
                            <label htmlFor={key}>
                              {translation[`${key}_label`] || key}
                            </label>

                            <label className="select">
  														<select
  															id={key}
                                defaultValue={reportFilters[key]}
  															onChange={(e) => this.handleChange(key, e.target.value, true)}
  														>
  															<option value="">{translation[`${key}_helper`]}</option>

  															{reportFilterMap[key].map(
  																(option, i) =>
  																<option
                                    key={i}
                                    value={option}
                                  >
                                    {translation.options[option] || option}
                                  </option>
  															)}
  														</select>
                            </label>
                          </li>
                        )
                      } else if(dataType === 'string' && reportFilterMap[key] !== 'date' && reportFilterMap[key] !== 'install') {
                        // String-based filter
                        return (
                          <li
                            key={i}
                          >
                            <label htmlFor={key}>
                              {translation[`${key}_label`] || key}
                            </label>

                            <input
                              id={key}
                              type="text"
                              // defaultValue={
                              //   reportFilters[key] ?
                              //   reportFilters[key].replace(/\*/g, '') :
                              //   ''
                              // }
                              onChange={(e) => this.handleChange(key, e.target.value)} placeholder={translation[`${key}_helper`] || ''}
                            />
                          </li>
                        )
                      } else if(dataType === 'string' && reportFilterMap[key] === 'date') {
                        // Date-based filter
  											let date = null;

                        if(this.state[key]) {
                          date = this.state[key];
                        } else if(reportFilters[key]) {
                          date = moment(reportFilters[key]);
                        }

  											return (
  												<li
  													key={i}
  												>
  													<label htmlFor={key}>
  														{translation[`${key}_label`] || key}
  													</label>

  													<DatePicker
  		                        id={key}
  		                        selected={date}
  		                        onChange={(date, e) => this.handleDateChange(date, key)}
  		                        placeholderText="mm/dd/yyyy"
  														autoComplete="off"
  		                      />
  												</li>
  											)
                      } else if(dataType === 'string' && reportFilterMap[key] === 'install') {
                        // Install drop-down

  											return (
  												<li
  													key={i}
  												>
  													<label htmlFor={key}>
  														{translation[`${key}_label`] || key}
  													</label>

  													<label className="select">
                              <select
                                onChange={(e) => this.handleChange('installSid', e.target.value, true)}
                              >
                                <option value="">{translation[`${key}_helper`] || key}</option>
                                {this.getInstitutions()}
                                {SessionStore.installs && SessionStore.installs.map(
                                  (install, i) =>
                                  <option key={i} value={install.installSid}>
                                    {install.accountName}
                                  </option>
                                )}
                              </select>
                            </label>
  												</li>
  											)
                      }

                      return null;
                    }
                  )}

                </ul>
              </fieldset>

              <button className="btn" type="submit">
                {translation.button}
              </button>
            </form>
          </div>
        </div>
      )
    }

    return null;
  }
})

export default translate('ReportFilter')(ReportFilter);



// WEBPACK FOOTER //
// ./src/app/components/Reports/ReportFilter.js